import React, {useState} from 'react';
import {
    TextInput,
    DateInput,
    SelectInput,
    Edit,
    TabbedForm,
    FormTab,
    required,
    CardActions,
    ListButton,
    Toolbar,
    SaveButton,
    Notification,
    ImageInput,
    ImageField,
    BooleanInput,
    ArrayInput,
    SimpleFormIterator,
} from 'react-admin';

import withStyles from '@material-ui/core/styles/withStyles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { Redirect } from 'react-router-dom';
import Allergies from '../controls/Allergies'
import Iframe from '../controls/Iframe'
import Questionnaire from './Questionnaire'
import IsNot2ndPhysical from './IsNot2ndPhysical';
import Sign from '../controls/Signature';
import SanitizedTextInput from '../controls/SanitizedTextInput';
import ErrorBoundary from '../ErrorBoundary';
const {  REACT_APP_CONSENT_URL } = process.env;

let ssn = null;
var qDonorSign = null;
var qExaminerSign = null;
var aDonorSign = null;
var aExaminerSign = null;
var tDonorSign = null;
var tExaminerSign = null;
var cDonorSign = null;
var cExaminerSign = null;
var data = null;

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const PhysicalEditActions = () => (
    <CardActions style={cardActionStyle}>
        <ListButton basePath={'/physicals?filter=%7B"ssn"%3A"' + ssn +'"%7D&order=DESC&page=1&perPage=25&sort=id'} label='Physical List'/>
    </CardActions>
);

const editStyles = {
    formTable: {
        margin: 'auto',
        width: '100%',
        fontSize: '12px',
        '& td': { padding: '6px 10px', verticalAlign: 'top' },
        '& tr:hover': { backgroundColor: 'transparent' },
        '& .MuiFormControl-root': { width: '100%' },
    },
    root: { alignItems: 'flex-start'},
    initial: {  width: '5em' },
    booth: {  width: '2em' },
    time: {  width: '7em' },
    volume: {  width: '3em' },
    comments: {  width: '30em' },
    inlineBlock: {
        display: 'inline-flex',
        margin: '5px',
        padding: '5px',
    },
};

  const location = [
    {
        id: 'Jacksonville',
        name: 'Jacksonville'
    },
    {
        id : 'MIAMI',
        name: 'MIAMI'
    }
  ]
const types = [
    {
        id : 'Applicant/New',
        name : 'Applicant/New'
    },
    {
        id: 'Annual',
        name: 'Annual'
    }
]

const anato = [
    {
        id: 'WNL',
        name: 'WNL'
    },
    {
        id: 'Abnomal',
        name: 'Abnomal'
    }
]
/*
const YesNoExt = [
    {
        id: 'Y',
        name: 'Yes'
    },
    {
        id : 'N',
        name: 'No'
    },
    {
        id : '/',
        name: 'N/A'
    }
  ]
*/
  const YesNo = [
    {
        id: 'Y',
        name: 'Yes'
    },
    {
        id : 'N',
        name: 'No'
    }
  ]


const deferralCodes = [
    {
        id: 'ID',
        name: 'Indefinitely Deferred'
    },
    {
        id: 'N/A',
        name: 'Not applicable'
    },
    {
        id: 'PR',
        name: 'Permanently rejected'
    },
    {
        id : 'TD',
        name: 'Temporarly Deferred'
    }
  ]


const PhysicalToolbar = props => (
    <Toolbar {...props} >
        <SaveButton
            label="save"
            transform={data => ({ ...data, q_don_sign: qDonorSign, 
                                q_exam_sign: qExaminerSign,
                                a_don_sign: aDonorSign, 
                                a_exam_sign: aExaminerSign,
                                t_don_sign: tDonorSign, 
                                t_exam_sign: tExaminerSign,
                                c_don_sign: cDonorSign, 
                                c_exam_sign: cExaminerSign    })}
            redirect={'/physicals?filter=%7B"ssn"%3A"' + ssn +'"%7D&order=DESC&page=1&perPage=25&sort=id'}
            submitOnEnter={true}
        />
    </Toolbar>
);

const GetKey=({ record }) => (
    data = record? record: null,
    ssn = (record.ssn)? record.ssn:ssn,
    (ssn)? '': <Redirect to="/donors" />
);

const setQDonSignatureValue=(image)=>{
    qDonorSign = image;
}
const setQExaminerSignatureValue=(image)=>{
    qExaminerSign = image;
}
const setADonSignatureValue=(image)=>{
    aDonorSign = image;
}
const setAExaminerSignatureValue=(image)=>{
    aExaminerSign = image;
}
const setTDonSignatureValue=(image)=>{
    tDonorSign = image;
}
const setTExaminerSignatureValue=(image)=>{
    tExaminerSign = image;
}
const setCDonSignatureValue=(image)=>{
    cDonorSign = image;
}
const setCExaminerSignatureValue=(image)=>{
    cExaminerSign = image;
}
/*
function showNext(val, id, to, validator){
    //alert(val)
    let i = 0;

    if(val === validator || val === "/"){
        document.getElementById("td_" + id).removeAttribute("style"); 
        for( i= id +1; i < id+to + 1;  i++)
            document.getElementById("hq_" + i).removeAttribute("style");
    }else{
        document.getElementById("td_" + id).setAttribute("style", "color: red;");
        for( i= id +1; i < 61;  i++)
            document.getElementById("hq_" + i).setAttribute("style", "display: none;");
    }
}
*/
const AnotoValidate=(val,id) =>(
    (val === 'WNL')? document.getElementById("tc_" + id).removeAttribute("style"): document.getElementById("tc_" + id).setAttribute("style", "color: red;")
)

const PhysicalEdit =({ classes, ...props }) => (
<ErrorBoundary>    
<Edit 
    title='Physical Exam | Edit' 
    {...props}  
    actions={<PhysicalEditActions/>} 
    >
       
    <TabbedForm toolbar={<PhysicalToolbar />}>        
            <FormTab label="Initial">       
                <GetKey props ={props}/>
                <Allergies />  
                <Table   className={classes.formTable} >                           
                    <TableBody>                 
                        <TableRow>
                            <TableCell  align="left"><SelectInput source='type'  label="Type" choices={types}  validate={required()}/></TableCell>
                            <TableCell  align="left"><SanitizedTextInput   source="ssn" label="Donor #"   defaultValue={ssn}  validate={required()}  disabled /></TableCell>
                            <TableCell  align="left"><SelectInput source='location'  label="Location" choices={location}  validate={required()}/></TableCell>
                        </TableRow> 
                    </TableBody>
                </Table>
                <Table   className={classes.formTable} >                           
                    <TableBody>  
                        <TableRow>  
                            <TableCell  align="left"><SanitizedTextInput source="auditor" label="Auditor Present During Physical Donor Consent" fullWidth /></TableCell>
                            <TableCell  align="left"><SanitizedTextInput source="donor_init" label="Donor Initial"  /></TableCell>
                        </TableRow>  
                        <TableRow>  
                            <TableCell  align="left"><BooleanInput source="chap_offered" label="Chaperone Offered?" /></TableCell>
                            <TableCell  aling="left" ><TextInput source="chap_offered_comments" label="Comments"  rowsMax={3} multiline fullWidth /></TableCell>
                        </TableRow>          
                        <TableRow>  
                            <TableCell colSpan="2"  align="left"><BooleanInput source="flipchart" label="Have you read and understood the Flipchart?"   validate={required()} /></TableCell>
                        </TableRow>       
                    </TableBody>
                </Table>
            </FormTab>
            <FormTab label="History Questionnaire">  
            <Allergies />  
            <Questionnaire />
            <table cellPadding={8} style={{width: '100%'}}>
                <tr>
                    <td colSpan="2" ><b>Comments:</b></td>
                </tr>
                <tr>
                    <td colSpan="2" ><TextInput source="f_comments" label=""  rowsMax={4} multiline fullWidth /></td>
                </tr>
                <tr>
                    <td colSpan="2" ><b>Acknowledgment:</b></td>
                </tr>
                <tr>
                    <td colSpan="2" >
                    1.	I have reviewed the educational materials regarding infections that can be transmitted by my donation, such as, Syphilis, HIV, Hepatitis B and C.<br />
                    2.	I agree not to donate if my donation could result in a potential risk to people who receive plasma products.<br />
                    3.	A sample of my blood will be tested for infections that can be transmitted by my donation, such as, Syphilis, HIV, Hepatitis B and C.<br />
                    4.	I understand you will attempt to notify me if for any reason I cannot donate and records will be maintained indicating the reason for the deferral and the deferral time period.<br />
                    5.	I have reviewed the information regarding the potential risks and hazards of donating Source Plasma.<br />
                    6.	I have been given the opportunity to ask questions and understand that I may withdraw from the donation procedure at any time.<br />
                    </td>
                </tr>
                <tr>
                    <td colSpan="2" >
                        <table width="100%">
                        <tr>
                            <td>Donor Signature: </td><td><Sign setSignatureValue={setQDonSignatureValue} url={data?data.f_don_sign: null} /></td>
                            <td>Date: </td><td><DateInput source="f_don_sign_date" label="" locales="en-us"></DateInput></td>
                        </tr>
                        <tr>
                            <td>Medical Examiner: </td><td><Sign setSignatureValue={setQExaminerSignatureValue} url={data?data.f_med_exam: null} /></td>
                            <td>Date: </td><td><DateInput source="f_med_exam_date" label="" locales="en-us"></DateInput></td>
                        </tr>
                        <tr>
                            <td>QA Review Initials: </td><td><SanitizedTextInput source="f_qa_init" label=""/></td>
                            <td>Date: </td><td><DateInput source="f_qa_date" label="" locales="en-us"></DateInput></td>
                        </tr>
                        </table>
                    </td>
                </tr>
            </table>
        
            </FormTab>

            {IsNot2ndPhysical(props.location.ssn) && 
            <FormTab label="Anatomic">   
                <Allergies />  
                <Table  className={classes.formTable}  >
                    <TableBody  >  
                        <TableRow>
                               
                                <TableCell  align="center" bgcolor="silver"  colSpan='2'></TableCell>
                                <TableCell  align="center" bgcolor="silver" > <b>Examination of Anatomical Area</b></TableCell>
                        </TableRow> 
                        <TableRow>
                                <TableCell>{' 1.'}</TableCell>
                                <TableCell  ><SelectInput source='appearance'  label="" choices={anato} onChange={value => AnotoValidate(value.target.value, 1)} /></TableCell>
                                <TableCell id='tc_1' ><b>{'General appearance:'}</b>{'Awake, alert and oriented and in no apparent distress, emotionally stable.'}</TableCell>
                        </TableRow> 
                        <TableRow>
                                <TableCell>{' 2.'}</TableCell>
                                <TableCell  ><SelectInput source='head'  label="" choices={anato}  onChange={value => AnotoValidate(value.target.value, 2)} /></TableCell>
                                <TableCell  id='tc_2'><b>{'Head:'}</b>{'Normocephalic, atraumatic, symmetrical, no scars.'}</TableCell>
                        </TableRow> 
                        <TableRow>
                                <TableCell>{' 3.'}</TableCell>
                                <TableCell  ><SelectInput source='eyes'  label="" choices={anato}  onChange={value => AnotoValidate(value.target.value, 3)} /></TableCell>
                                <TableCell  id='tc_3'><b>{'Eyes:'}</b>{'White conjunctiva, pupils equal round and reactive to light and accommodation, extraocular muscles intact bilaterally. No sclera icterus.'}</TableCell>
                        </TableRow> 
                        <TableRow>
                                <TableCell>{' 4.'}</TableCell>
                                <TableCell  ><SelectInput source='ears'  label="" choices={anato}  onChange={value => AnotoValidate(value.target.value, 4)} /></TableCell>
                                <TableCell id='tc_4'><b>{'Ears:'}</b>{'Symmetrical without any tenderness, discharged or erythema in external canals bilaterally. Tympanic memberanes are clear without any erythema bilaterally.'}</TableCell>
                        </TableRow> 
                        <TableRow>
                                <TableCell>{' 5.'}</TableCell>
                                <TableCell  ><SelectInput source='nose'  label="" choices={anato}  onChange={value => AnotoValidate(value.target.value, 5)} /></TableCell>
                                <TableCell  id='tc_5'><b>{'Nose:'}</b>{'Symmetrical without any tenderness or discharge. No inflammation or nasal mucosa bilaterally. No septal perforation.'}</TableCell>
                        </TableRow> 
                        <TableRow>
                                <TableCell>{' 6.'}</TableCell>
                                <TableCell  ><SelectInput source='mouth'  label="" choices={anato}  onChange={value => AnotoValidate(value.target.value, 6)} /></TableCell>
                                <TableCell id='tc_6'><b>{'Mouth and Throat:'}</b>{'Clear without erythema or exudates in posterior oropharynx. Pink mucosa on tongue and tonsils (if present). No ulcerations or needle marks present.'}</TableCell>
                        </TableRow> 
                        <TableRow>
                                <TableCell>{' 7.'}</TableCell>
                                <TableCell  ><SelectInput source='neck'  label="" choices={anato}  onChange={value => AnotoValidate(value.target.value, 7)} /></TableCell>
                                <TableCell id='tc_7'><b>{'Neck /Lymphatic:'}</b>{'No scars noted. No masses palpated. No thyromegaly. No enlarged or tender nodules. No cervical, posterior auricular or supraclavicular lymphadenopathy.  No axillary adenopathy.'}</TableCell>
                        </TableRow> 
                        <TableRow>
                                <TableCell>{' 8.'}</TableCell>
                                <TableCell  ><SelectInput source='heart'  label="" choices={anato}  onChange={value => AnotoValidate(value.target.value, 8)} /></TableCell>
                                <TableCell id='tc_8'><b>{'Heart:'}</b>{'Regular rate and rhythm with no murmurs, gallops, rubs or clicks. No additional heart sounds.'}</TableCell>
                        </TableRow> 
                        <TableRow>
                                <TableCell>{' 9.'}</TableCell>
                                <TableCell  ><SelectInput source='lungs'  label="" choices={anato}  onChange={value => AnotoValidate(value.target.value, 9)} /></TableCell>
                                <TableCell id='tc_9'><b>{'Lungs:'}</b>{'Clear to auscultation in all fields bilaterally. No wheezes, rales or rhonchi.'}</TableCell>
                        </TableRow> 
                        <TableRow>
                                <TableCell>{' 10.'}</TableCell>
                                <TableCell  ><SelectInput source='abdomen'  label="" choices={anato}  onChange={value => AnotoValidate(value.target.value, 10)} /></TableCell>
                                <TableCell id='tc_10'><b>{'Abdomen:'}</b>{'No scars noted. Soft, non-tender. No guarding or rebound tenderness. No palpable masses. No hepato-splenomegaly.'}</TableCell>
                        </TableRow> 
                        <TableRow>
                                <TableCell>{' 11.'}</TableCell>
                                <TableCell  ><SelectInput source='neurological'  label="" choices={anato}  onChange={value => AnotoValidate(value.target.value, 11)} /></TableCell>
                                <TableCell id='tc_11'><b>{'Neurological:'}</b>{'Normal gait and balance. No tremors. Mental status and speech appropriate. Deep tendon reflexes are symmetric bilaterally. No facial asymmetries.'}</TableCell>
                        </TableRow> 
                        <TableRow>
                                <TableCell>{' 12.'}</TableCell>
                                <TableCell  ><SelectInput source='muscul'  label="" choices={anato}  onChange={value => AnotoValidate(value.target.value, 12)} /></TableCell>
                                <TableCell id='tc_12'><b>{'Musculoskeletal/Extremities:'}</b>{'No obvious deformities noted.  No edema.'}</TableCell>
                        </TableRow> 
                        <TableRow>
                                <TableCell>{' 13.'}</TableCell>
                                <TableCell  ><SelectInput source='skin'  label="" choices={anato}  onChange={value => AnotoValidate(value.target.value, 13)} /></TableCell>
                                <TableCell id='tc_13'><b>{'Skin:'}</b>{'No suspicious needle marks. No suspicious lesions. No infections, rashes, bruises, scarring or masses.'}</TableCell>
                        </TableRow> 
                        <TableRow>
                                <TableCell colSpan='3'><TextInput source="physical_exam_comments" label="Comments" rowsMax={4} multiline fullWidth /></TableCell>
                        </TableRow> 
                    </TableBody>
                </Table>
                <Table   className={classes.formTable} >                           
                    <TableBody>                 
                        <TableRow>
                            <TableCell  align="left" colSpan="2">{'High Risk Assessment Quiz Completed Initial:'}</TableCell>
                            <TableCell  align="left"><SanitizedTextInput source='quiz_comp_initial' label=''/></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell  align="left">{'Donor Suitable for Donation?'}<SelectInput source="suitable" label="" choices={YesNo}  validate={required()}/></TableCell>
                            <TableCell><SanitizedTextInput source="suitable_initial"  label="Initial" /></TableCell>
                            <TableCell><DateInput source="suitable_date"  label="Date" locales="en-us"/></TableCell>
                        </TableRow> 
                        <TableRow>
                            <TableCell  align="left" >{'Donor Signature:'}<Sign setSignatureValue={setADonSignatureValue} url={data?data.quiz_don_sign: null} /></TableCell>
                            <TableCell  align="left">{"Examinor's Signature:"}<Sign setSignatureValue={setAExaminerSignatureValue} url={data?data.quiz_exam_sign: null} /></TableCell>
                            <TableCell ><DateInput source="quiz_exam_date"  label="Date" locales="en-us"/></TableCell>
                        </TableRow> 
                        <TableRow>
                            <TableCell  align="left" ><SelectInput source="deferral_code"    label="Deferral code" choices={deferralCodes}    de /></TableCell>
                            <TableCell  align="left" ><DateInput source="deferral_date"    label="Deferral date" locales="en-us"   /></TableCell>
                            <TableCell  align="left" ><DateInput source="deferral_exp_date"    label="Deferral Exp date" locales="en-us"    /></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell  align="left" colSpan="3"><TextInput source="deferral_comments" rowsMax={4} multiline fullWidth  label="Deferral comments"  /></TableCell>
                        </TableRow> 
                    </TableBody>
                </Table> 
            </FormTab>
            }
            {IsNot2ndPhysical(props.location.ssn) && 
            <FormTab label="Tattoo">   
                <Allergies />  
                <Table   className={classes.formTable} >
                <TableBody  > 
                    <TableRow > 
                        <TableCell colSpan="3" ><b>Description (Tattoo/Body Piercing):</b><br/><SanitizedTextInput source="tattoo_desc" label=""  rowsMax={3} multiline fullWidth /></TableCell>                       
                    </TableRow > 
                    <TableRow > 
                        <TableCell  colSpan="3"><b>{'Donor Verification Statment:'}</b>{'This body map is an accurate representation of all my piercings (including closed piercings) gauging, '
                        + 'and/or tattoos, touch ups and/or brandings, and scarifications.  I agree to notify center staff if I receive any new tattoos, piercings, gauging,  brandings, or scarifications.'}
                         </TableCell>                       
                    </TableRow > 
                    <TableRow>
                        <TableCell>{"Donor's signature:"}<Sign setSignatureValue={setTDonSignatureValue} url={data?data.desc_don_sign: null} /></TableCell>
                        <TableCell>{"Examinor's Signature:"}<Sign setSignatureValue={setTExaminerSignatureValue} url={data?data.desc_exam_sign: null} /></TableCell>
                        <TableCell ><DateInput source="desc_exam_date"  label="Date" locales="en-us" /></TableCell>
                    </TableRow>
                </TableBody  > 
                </Table>
                <Table   className={classes.formTable} >
                <TableBody  > 
                    <TableRow > 
                        <TableCell ><b>Tattoo /Piercing image </b>(<font color="blue">Add/Update</font>):<br />
                            <ImageInput source="tattoo_img" label="" accept="image/*" minSize={0} maxSize={2000000}>
                            <ImageField source="src" title="Tattoo" />
                            </ImageInput>
                        </TableCell>
                    </TableRow>
                    <TableRow > 
                        <TableCell ><b>Tattoo / Piercing image </b>(<font color="blue">View</font>):<br />
                            <ImageField source="tattoo_img_url" label="" />
                        </TableCell>
                    </TableRow>
                </TableBody>
                </Table>
                <Table className={classes.formTable} >
                    <TableBody>
                    <TableRow>
                            <TableCell  align="left" ><SelectInput source="deferral_code"    label="Deferral code" choices={deferralCodes}     /></TableCell>
                            <TableCell  align="left" ><DateInput source="deferral_date"    label="Deferral date" locales="en-us"   /></TableCell>
                            <TableCell  align="left" ><DateInput source="deferral_exp_date"    label="Deferral Exp date" locales="en-us"    /></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell  align="left" colSpan="3"><TextInput source="deferral_comments"  rowsMax={4} multiline fullWidth  label="Deferral comments"  /></TableCell>
                        </TableRow> 
                    </TableBody>
                </Table>
            </FormTab>
            }
            {IsNot2ndPhysical(props.location.ssn) && 
            <FormTab label="Medications">   
                <Allergies />  
                <ArrayInput source="medications" label='Medication(s)'>
                    <SimpleFormIterator>
                        <SanitizedTextInput source='med_name' label = 'Medication Name' formClassName={classes.inlineBlock}/>
                        <BooleanInput source='med_accept' label = 'Is this Medication acceptable?' formClassName={classes.inlineBlock} />
                        <DateInput source="med_s_date" label='Start Date'  locales="en-us" formClassName={classes.inlineBlock}/>
                        <SanitizedTextInput source="med_s_init" label='Initial' formClassName={classes.inlineBlock} />
                        <DateInput source="med_s_init_date" label='Date' locales="en-us" formClassName={classes.inlineBlock} />
                        <DateInput source="med_e_date" label='Stop Date' locales="en-us" formClassName={classes.inlineBlock}/>
                        <SanitizedTextInput source="med_e_init" label='Initial' formClassName={classes.inlineBlock}/>
                        <DateInput source="med_e_init_date" label='Date' locales="en-us" formClassName={classes.inlineBlock}/>
                        <TextInput source="med_comments" label='Comments' formClassName={classes.inlineBlock} rowsMax={3} multiline />
                        <TextInput source="med_qa_review" label='QA Review' formClassName={classes.inlineBlock} rowsMax={3} multiline />
                    
                    </SimpleFormIterator>
                </ArrayInput>
                <Table   className={classes.formTable} >
                    <TableBody  > 
                        <TableRow > 
                            <TableCell>{'Donor Suitable for Donation?'}<SelectInput source="suitable" label="" choices={YesNo}  validate={required()}/></TableCell>
                            <TableCell><SanitizedTextInput source="suitable_initial"  label="Initial" /></TableCell>
                            <TableCell><DateInput source="suitable_date"  label="Date" locales="en-us"/></TableCell>
                        </TableRow>
                        <TableRow > 
                            <TableCell>{'QA Reviwe Initial'}<SanitizedTextInput source="med_qa_init" label=""/></TableCell>
                            <TableCell colSpan="2"><DateInput source="med_qa_date"  label="Date" locales="en-us"/></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell  align="left" ><SelectInput source="deferral_code"    label="Deferral code" choices={deferralCodes}    /></TableCell>
                            <TableCell  align="left" ><DateInput source="deferral_date"    label="Deferral date" locales="en-us"   /></TableCell>
                            <TableCell  align="left" ><DateInput source="deferral_exp_date"    label="Deferral Exp date" locales="en-us"  /></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell  align="left" colSpan="3"><TextInput source="deferral_comments"   rowsMax={4} multiline fullWidth  label="Deferral comments"   /></TableCell>
                        </TableRow> 
                    </TableBody>
                </Table>
            </FormTab>
            }
            {IsNot2ndPhysical(props.location.ssn) && 
            <FormTab label="Consent" id="consent">  
                <Allergies />   
                <div style={{width: "100%"}} align="center" >
                    <h2>Plasmapheresis Informed Consent</h2>
                    <Iframe source={REACT_APP_CONSENT_URL}  />
                </div>
                <Table className={classes.formTable} >
                    <TableBody>
                        <TableRow>
                            <TableCell>Donor Signature: </TableCell>
                            <TableCell align="left"><Sign setSignatureValue={setCDonSignatureValue} url={data?data.pla_don_sign: null} /></TableCell>
                            <TableCell>Date: </TableCell><TableCell align="left"><DateInput source="pla_don_sign_date" label="" locales="en-us" /></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Medical Examiner Signature: </TableCell>
                            <TableCell align="left"><Sign setSignatureValue={setTExaminerSignatureValue} url={data?data.mad_exam_sign: null} /></TableCell>
                            <TableCell>Date: </TableCell><TableCell align="left"><DateInput source="mad_exam_sign_date" label="" locales="en-us" /></TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
                <Table className={classes.formTable} >
                    <TableBody>
                        <TableRow > 
                            <TableCell>Donor Suitable for Donation?</TableCell><TableCell  align="left"><SelectInput source="suitable" label="" choices={YesNo}  validate={required()}/></TableCell>
                            <TableCell>Initial:</TableCell><TableCell  align="left"><SanitizedTextInput source="suitable_initial"  label="" /></TableCell>
                            <TableCell>Date:</TableCell><TableCell  align="left"><DateInput source="suitable_date"  label="" locales="en-us"/></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell  colSpan="2"><SelectInput source="deferral_code"    label="Deferral code" choices={deferralCodes}    /></TableCell>
                            <TableCell  colSpan="2"><DateInput source="deferral_date"    label="Deferral date" locales="en-us"   /></TableCell>
                            <TableCell  colSpan="2"><DateInput source="deferral_exp_date"    label="Deferral Exp date" locales="en-us"  /></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell  align="left" colSpan="6"><TextInput source="deferral_comments"   rowsMax={4} multiline fullWidth  label="Deferral comments"   /></TableCell>
                        </TableRow> 
                    </TableBody>
                </Table>
             </FormTab>
             }
        </TabbedForm>
    </Edit>
    </ErrorBoundary>
);

export default withStyles(editStyles)(PhysicalEdit);